import * as React from 'react';
import { SingleValueComponent } from '../common/types';
import { FaSearch } from 'react-icons/fa';
import { keyCodeTypes } from '../common/key-code-types';
import { ButtonInputGroup } from '../common';

import styles from './search.scss';
import { DebounceInput } from 'ui/common/debounce-input';
import { GlobalHandlers, GlobalHotKeys, KeyMap } from 'ui/common/hotkeys';

const notNumberReg = /[^0-9\s,-]/g;

/**
 * Search component is a part view for searching feature.
 */
export interface SearchProps extends SingleValueComponent<string> {
  /**
   * Define callback method which is called after click on search icon.
   */
  onSearch: () => void;
  maxLength?: number;
  minLength?: number;
  wait?: number;
}

export class Search extends React.Component<SearchProps> {
  private keyMap: KeyMap;
  private handlers: GlobalHandlers;
  constructor(props: SearchProps) {
    super(props);
    this.keyMap = {
      onEnter: [keyCodeTypes.Enter, keyCodeTypes.NumpadEnter]
    };
    this.handlers = {
      onEnter: this.onSearch
    };
  }

  private onSearch = () => {
    if (!this.isDisabled()) {
      this.props.onSearch();
    }
  };

  private isDisabled() {
    const { minLength, value } = this.props;

    return minLength !== undefined && (value.length === 0 || (value.length < minLength && value.search(notNumberReg) !== -1));
  }

  private onFocus = (event: React.FormEvent<any>) => {
    // fix for setting the cursor at the end of value for chrome
    const targetObj = event.target as HTMLInputElement;
    const value = targetObj.value;
    targetObj.value = '';
    targetObj.value = value;
  };

  public render() {

    return (
      <GlobalHotKeys keyMap={this.keyMap} handlers={this.handlers}>
        <div className={this.props.className} id={this.props.componentId}>
          <div className="input-group">
            <DebounceInput
              type="search"
              className="form-control"
              readOnly={this.props.readOnly}
              maxLength={this.props.maxLength}
              value={this.props.value}
              placeholder={this.props.placeholder}
              onChange={this.props.onChange}
              focus={this.props.focus}
              onFocus={this.onFocus}
              wait={this.props.wait} />
            <span className="input-group-btn">
              <ButtonInputGroup
                className={styles.button}
                icon={FaSearch}
                onClick={this.props.onSearch}
                callToAction={true}
                disabled={this.isDisabled()} />
            </span>
          </div>
        </div>
      </GlobalHotKeys>
    );
  }
}
